module.exports = __webpack_public_path__ + "static/media/icon-players.13f6a13d.png";